import React from 'react';
import {FormControl, TextField} from "@material-ui/core";
import {Autocomplete} from "@material-ui/lab";

// <Tooltip
//   title="Press return to add new items."
//   style={{marginLeft: '0.5em'}}
//   PopperProps={{style: {fontSize: '1rem'}}}
//   onClose={handleTooltipClose}
//   open={open}
// >
//   <InfoIcon
//     onMouseOver={handleTooltipOpen}
//     onFocus={handleTooltipOpen}
//     onTouchStart={handleTooltipOpen}
//     onClick={handleTooltipOpen}/>
// </Tooltip>
export default function TagAutocomplete({ label, items, options, getOptionLabel, updateItems, margin="dense", ...rest }) {

  // const [open, setOpen] = React.useState(false);

  // const handleTooltipClose = () => {
  //   setOpen(false);
  // };
  // const handleTooltipOpen = () => {
  //   open || setOpen(true);
  // };

  const getOptOrStrLabel = opt => typeof(opt) === "string" ? opt : getOptionLabel(opt);

  return (
    <FormControl {...rest} size="small" margin={margin} fullWidth>
      <Autocomplete
        multiple
        freeSolo
        autoSelect
        value={items}
        options={options.filter(opt => !items.find(i => getOptOrStrLabel(i) === getOptOrStrLabel(opt)))}
        getOptionLabel={getOptOrStrLabel}
        onChange={(event, value) => updateItems(value)}
        renderInput={params => <TextField {...params} variant="outlined" label={label}/>}
        size="small"
        margin='dense'
      />
    </FormControl>
  );
}
